import { KydSmartphoneEnrolledOperatorContactDetailModel } from './kyd-smartphone-enrolled-operator-contact-detail.model';
import { KydSmartphoneEnrolledOperatorEnrollmentSummaryModel } from './kyd-smartphone-enrolled-operator-enrollment-summary.model';

export class KydSmartphoneEnrolledOperatorModel {
  public cdhId: string;
  public contactDetail: KydSmartphoneEnrolledOperatorContactDetailModel;
  public operatorEnrollmentSummary: KydSmartphoneEnrolledOperatorEnrollmentSummaryModel;
}
